export default __webpack_public_path__ + "static/media/login-bg.85cb05d1.png";